
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    auraSetting: {
      displayAmount: "",
    },
  };
  url = "/api/corp/config/get";
  page = 1;
  value = "";
  items = ["Full Fare without Taxes", "Full Fare With Taxes"];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
      // console.log(this.corporateConfig);
      if (
        this.corporateConfig.auraSetting.displayAmount == undefined ||
        this.corporateConfig.auraSetting.displayAmount == ""
      ) {
        this.value = "Full Fare With Taxes";
      } else {
        this.value = "Full Fare without Taxes";
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async save() {
    try {
      if (this.value == "Full Fare without Taxes") {
        this.corporateConfig.auraSetting.displayAmount = "1";
      } else {
        this.corporateConfig.auraSetting.displayAmount = "";
      }
      common.setLoading(true);
      await doPost("/api/corp/config/aura/save", this.corporateConfig);

      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
